/*
 * GA4 ecommerce events for the GTM data layer (KK-70, KK-90).
 * Page-level events (view_item, view_cart, search) are pushed from snippets/gtm-head.liquid.
 * Checkout events (begin_checkout to purchase) come from the "GTM - checkout" custom pixel.
 */
(function () {
  const dataLayer = (window.kkDataLayer = window.kkDataLayer || []);
  const config = window.kkGtm || {};
  const currency = config.currency;
  const listName = config.listName;

  function pushEcommerce(event, items, extra) {
    if (!items.length) return;
    const value = items.reduce((sum, item) => sum + (item.price || 0) * (item.quantity || 1), 0);
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event,
      ecommerce: Object.assign({ currency, value: Math.round(value * 100) / 100, items }, extra),
    });
  }

  function cardItem(card, index) {
    try {
      return Object.assign(JSON.parse(card.dataset.gtmItem), { index, item_list_name: listName });
    } catch (e) {
      return null;
    }
  }

  // view_item_list: the main product grid on collection and search pages.
  // Facet filtering and sorting replace the grid, so push again when it changes.
  function pushItemList() {
    const grid = document.getElementById('product-grid');
    if (!grid) return;
    const items = Array.from(grid.querySelectorAll('[data-gtm-item]'))
      .map((card, i) => cardItem(card, i))
      .filter(Boolean);
    pushEcommerce('view_item_list', items, { item_list_name: listName });
  }

  if (config.pageType === 'collection' || config.pageType === 'search') {
    pushItemList();
    const container = document.getElementById('ProductGridContainer');
    if (container) {
      let timer;
      new MutationObserver(() => {
        clearTimeout(timer);
        timer = setTimeout(pushItemList, 500);
      }).observe(container, { childList: true });
    }
  }

  // select_item: a click on any product card link.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="/products/"]');
    const card = link && link.closest('[data-gtm-item]');
    if (!card) return;
    const cards = Array.from(document.querySelectorAll('[data-gtm-item]'));
    const item = cardItem(card, cards.indexOf(card));
    if (item) pushEcommerce('select_item', [item], { item_list_name: listName });
  });

  // add_to_cart / remove_from_cart: compare the cart before and after every cart change,
  // so the product form, cart drawer, cart page and quick add are all covered.
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const originalFetch = window.fetch.bind(window);
  let cartLines = null;
  let queue = Promise.resolve();

  function cartItem(line, quantity) {
    return {
      item_id: String(line.sku || line.variant_id),
      item_name: line.product_title,
      item_brand: line.vendor,
      item_category: line.product_type,
      item_variant: line.variant_title || undefined,
      price: line.final_price / 100,
      quantity,
    };
  }

  function readCart() {
    return originalFetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  }

  function toLines(cart) {
    const lines = {};
    cart.items.forEach((line) => {
      lines[line.key] = line;
    });
    return lines;
  }

  function diffCart() {
    queue = queue
      .then(readCart)
      .then((cart) => {
        const next = toLines(cart);
        const previous = cartLines || {};
        const added = [];
        const removed = [];
        Object.keys(next).forEach((key) => {
          const delta = next[key].quantity - (previous[key] ? previous[key].quantity : 0);
          if (delta > 0) added.push(cartItem(next[key], delta));
          if (delta < 0) removed.push(cartItem(next[key], -delta));
        });
        Object.keys(previous).forEach((key) => {
          if (!next[key]) removed.push(cartItem(previous[key], previous[key].quantity));
        });
        cartLines = next;
        pushEcommerce('add_to_cart', added);
        pushEcommerce('remove_from_cart', removed);
      })
      .catch(() => {});
  }

  queue = readCart()
    .then((cart) => {
      cartLines = toLines(cart);
    })
    .catch(() => {});

  window.fetch = function (input) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const request = originalFetch.apply(window, arguments);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      request.then((response) => {
        if (response.ok) diffCart();
      });
    }
    return request;
  };

  // login, sign_up and newsletter signups. Shopify posts these forms and reloads the page,
  // so the event marks the attempt; GA4's beacon transport sends it before the page unloads.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    const type = form.querySelector('input[name="form_type"]');
    if (!type) return;
    if (type.value === 'customer_login') dataLayer.push({ event: 'login', method: 'email' });
    if (type.value === 'create_customer') dataLayer.push({ event: 'sign_up', method: 'email' });
    if (type.value === 'customer' && form.querySelector('input[name="contact[tags]"][value*="newsletter"]')) {
      dataLayer.push({ event: 'newsletter_signup', form_location: form.id || form.className });
    }
  });
})();
